// ----------- Root URL -----------
export const ROOT_URL = process.env.NEXT_PUBLIC_ROOT || "/";

// ----------- API URL -----------
export const API_URL = process.env.NEXT_PUBLIC_API_URL || "/";

// ----------- DASHBOARD URL -----------
export const DASHBOARD_ROOT = process.env.NEXT_PUBLIC_DASHBOARD_ROOT || "/";

// ----------- BLOG URL -----------
export const BLOG_ROOT = process.env.NEXT_PUBLIC_BLOG_ROOT || "/";

// ----------- FOLIO URL -----------
export const FOLIO_ROOT = process.env.NEXT_PUBLIC_FOLIO_ROOT || "/";

// ----------- FOLIO API URL -----------
export const FOLIO_API_URL = process.env.NEXT_PUBLIC_FOLIO_API_URL || "/";

// ----------- NODE API URL -----------
export const NODE_API_URL = process.env.NEXT_PUBLIC_NODE_API_URL || "/";
